import Vue from 'vue'

// Estado de recolhimento do dock de atalhos flutuantes (Agente CRM 360, IA,
// Atendimento). Persistido em localStorage para sobreviver a reloads.
const STORAGE_KEY = 'aawz_floating_dock_collapsed'

// Id do trilho compartilhado (div renderizada por main.vue) para onde os
// widgets fora da árvore do layout se portalizam (ex.: OptionsTourManual).
// Fonte única — evita o mesmo literal duplicado em main.vue, no componente
// que se portaliza e em ambos os arquivos de teste.
export const FLOATING_DOCK_ID = 'aawz-floating-dock'

// Lê o estado persistido. Em modo privado/quota cheia o acesso pode lançar —
// nesse caso logamos e assumimos "expandido" (false) para nao quebrar o layout.
export function readDockCollapsed() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('FloatingDock: falha ao ler estado no localStorage', e)
    return false
  }
}

// Persiste o estado. Falha de storage e logada (a UI segue funcionando, so
// nao lembra a preferencia no proximo reload).
export function writeDockCollapsed(collapsed) {
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? 'true' : 'false')
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('FloatingDock: falha ao salvar estado no localStorage', e)
  }
}

// Registro de widgets do dock que não são montados pelo main.vue diretamente
// (ex.: OptionsTourManual — renderizado por ~17 views diferentes, portalizado
// pro trilho #aawz-floating-dock em vez de renderizado ali). main.vue.hasDockWidgets
// só conhece os 3 widgets que ele mesmo monta (Chat IA/Atendimento/Agente 360);
// sem este registro, uma view com OptionsTourManual mas nenhum dos 3 widgets
// visíveis (ex.: cliente final, ou escritório sem as features) fica com o FAB
// "?" órfão — sem o handle de recolher (main.vue, `v-if="hasDockWidgets"`), o
// FAB nunca sai da tela. Contador reativo (Vue.observable) em vez de GlobalBus:
// precisa ser LIDO dentro de um computed (hasDockWidgets) pra manter a
// reatividade — evento é fire-and-forget, não dá pra "perguntar o estado atual".
const registry = Vue.observable({ count: 0 })

export function registerDockWidget() {
  registry.count += 1
}

export function unregisterDockWidget() {
  registry.count = Math.max(0, registry.count - 1)
}

export function hasRegisteredDockWidgets() {
  return registry.count > 0
}
